import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '../locales/en.json';
import esTranslations from '../locales/es.json';
import itTranslations from '../locales/it.json';
import nlTranslations from '../locales/nl.json';

// Language resources
const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  it: { translation: itTranslations },
  nl: { translation: nlTranslations },
};

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en', // Get saved language or default to English
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

// Save language preference when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
